//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('activityType', {
//        templateUrl: 'views/components/views/activityType/activityType.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'custactEditService', 'activityTypeService', function ($stateParams, stateService, modalService, translateService, custactEditService, activityTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let activityTypeNo = $stateParams.activitytype_no;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                activityTypeNo: activityTypeNo,
//                activityTypeNameButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('activitytypelangs', { activitytype_no: vm.model.edit.activitytype_no }) }
//                ],
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await custactEditService.getActivityType({ activitytype_no: activityTypeNo }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                activityTypeService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    activityTypeService.deleteItem({ activitytype_no: vm.model.edit.activitytype_no }).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
